import { addShuntAccount , GetQrCodeStatus, CheckShuntAccount , getReceiverQrcode, checkReciver } from "@/api/AddRecipientInfo";

const state = {
  addShuntAccount:{},
  GetQrCodeStatus:{},
  CheckShuntAccount:{}
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  addShuntAccount({ commit },params) {
    return new Promise((resolve)=>{
      addShuntAccount(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'addShuntAccount',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      })
    })
  },
  getReceiverQrcode({ commit },params) {
    return new Promise((resolve)=>{
      getReceiverQrcode(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'getReceiverQrcode',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      })
    })
  },
  GetQrCodeStatus({ commit },params) {
    return new Promise((resolve)=>{
      GetQrCodeStatus(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetQrCodeStatus',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      })
    })
  },
  CheckShuntAccount({ commit },data) { // 获取更换微信二维码
    return new Promise((resolve)=>{
      CheckShuntAccount(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'CheckShuntAccount',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  checkReciver({ commit },data) { // 验证接收人姓名是否存在
    return new Promise((resolve)=>{
      checkReciver(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'checkReciver',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
